import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Images } from '@/assets';
import { colors } from '@/theme/colors';

const LoginBanner = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Section>
        <BannerTitle>{t('home')}</BannerTitle>
        <BannerTitle>·</BannerTitle>
        <BannerTitle data-active={true}>{t('login')}</BannerTitle>
      </Section>
      <TitleSection className="tit-head">
        <Title>{t('login')}</Title>
        <LogoImg src={Images.IllustLogin} alt="Log in illustration" />
      </TitleSection>
    </div>
  );
};

export default LoginBanner;

const Section = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  font-size: 15px;
  font-weight: 700;
`;

const BannerTitle = styled.div`
  color: ${colors.loginBannerTitle};
  &[data-active='true'] {
    color: ${colors.primaryBg};
  }
`;

const TitleSection = styled.div`
  display: flex;
  gap: 50px;
`;

const Title = styled.h1`
  font-weight: 600;
  font-size: 100px;
  margin: 0;
`;

const LogoImg = styled.img`
  height: 100%;
`;
